enum DiscordAuthCallbackParam {
  DiscordAuthSuccess = "discordAuthSuccess",
  FailureReason = "failureReason",
}

export default DiscordAuthCallbackParam;
